import * as React                                        from 'react';
import PropTypes                                         from 'prop-types';
import HotTable                                          from "react-handsontable";
import Handsontable                                      from "handsontable";
import { FormattedNumber, injectIntl }                   from 'react-intl';
import Result                                            from '../../../model/result';

const PROP_NAMES = { LABEL: "label" }
const fontStyle  = "bold"

class FonctComponent extends React.Component {
    constructor(props) {
		super(props);
	}
	render() {
		const props    = this.props;
        const years    = props.years
		const lastYear = _.last(years)
		const settings = {
			afterChange: function(changes, source) {
				if (source === "edit") {
					props.onAfterChange(changes, props.localAuthority);
				}
			},
			cells: function(row, col, prop) {
				// getting source data of the row
				const rowData   = this.instance.getSourceDataAtRow(row)
				// creating cell properties
				const cellProps = {}
				cellProps.renderer = function(instance, TD, row, col2, prop2, value, cellProperties) {
					if ("label" !== prop) { // if prop is not label (ex.: 2013, 2012, etc.)
						// applying the numeric renderer
						Handsontable.renderers.NumericRenderer.apply(this, arguments)
					} else {
						// applying the text renderer
						Handsontable.renderers.TextRenderer.apply(this, arguments)
					}

					// setting styles depending of rowData
					if (rowData && (rowData.isTitle)) {
						TD.style.fontWeight = fontStyle
					}
				}

				if (!rowData || !rowData.editable || col === 0 || (rowData.loading && rowData.loading[prop])) {
					cellProps.readOnly = true
				}

				if (rowData && !rowData.isCurrency) cellProps.format = "0,0"

				return cellProps
			},
			colHeaders: _.concat([""], years),
			columns   : [
				{ data: PROP_NAMES.LABEL },
				...this._getYearColumns(years)
			],
			data      : this.props.data,
			fixedColumnsLeft: 1,
			renderAllRows: true,
			stretchH  : "all"
        }

		return (
			<HotTable settings={settings}/>
		);
	}

    _getCurrencyNumber = (value) => <FormattedNumber currency="EUR" style="currency" value={value} />

    _getYearColumns = (years) => {
		const columns   = []
		const firstYear = years[0]

		for (let i = firstYear; i < firstYear + years.length; i++) {
			columns.push({ data: i.toString(), format: "0,0.00 $", language: "fr-FR", type: "numeric" })
		}

		return columns
	}
}

export default injectIntl(FonctComponent)


// WEBPACK FOOTER //
// ./src/component/summary/operation/fonct-component.js